/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceCustomerGroupRef } from "./BigCommerceCustomerGroupRef";
import {
  BigCommerceCustomerGroupRefFromJSON,
  BigCommerceCustomerGroupRefFromJSONTyped,
  BigCommerceCustomerGroupRefToJSON,
  BigCommerceCustomerGroupRefToJSONTyped,
} from "./BigCommerceCustomerGroupRef";

/**
 * The store's customer groups for the exceptions pickers, in the merchant's app and in Hubble. \[problem\] says why the list is empty when it couldn't be read, such as a permission the app doesn't have yet; null when it was read.
 * @export
 * @interface BigCommerceCustomerGroupsResponse
 */
export interface BigCommerceCustomerGroupsResponse {
  /**
   *
   * @type {Array<BigCommerceCustomerGroupRef>}
   * @memberof BigCommerceCustomerGroupsResponse
   */
  groups: Array<BigCommerceCustomerGroupRef>;
  /**
   *
   * @type {string}
   * @memberof BigCommerceCustomerGroupsResponse
   */
  problem?: string | null;
}

/**
 * Check if a given object implements the BigCommerceCustomerGroupsResponse interface.
 */
export function instanceOfBigCommerceCustomerGroupsResponse(
  value: object,
): value is BigCommerceCustomerGroupsResponse {
  if (!("groups" in value) || value["groups"] === undefined) return false;
  return true;
}

export function BigCommerceCustomerGroupsResponseFromJSON(
  json: any,
): BigCommerceCustomerGroupsResponse {
  return BigCommerceCustomerGroupsResponseFromJSONTyped(json, false);
}

export function BigCommerceCustomerGroupsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceCustomerGroupsResponse {
  if (json == null) {
    return json;
  }
  return {
    groups: (json["groups"] as Array<any>).map(
      BigCommerceCustomerGroupRefFromJSON,
    ),
    problem: json["problem"] == null ? undefined : json["problem"],
  };
}

export function BigCommerceCustomerGroupsResponseToJSON(
  json: any,
): BigCommerceCustomerGroupsResponse {
  return BigCommerceCustomerGroupsResponseToJSONTyped(json, false);
}

export function BigCommerceCustomerGroupsResponseToJSONTyped(
  value?: BigCommerceCustomerGroupsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    groups: (value["groups"] as Array<any>).map(
      BigCommerceCustomerGroupRefToJSON,
    ),
    problem: value["problem"],
  };
}
